# Used by Credit
# Autocomplete for company search. Allows to search and select a company

import _ from 'lodash'

K_ENTER = 13
_xhr = null

customEvent = document.createEvent('Event')
customEvent.initEvent('toggleVisibility', true, true)

selectResult = ($el) ->
  if $el.is(':not(.summary--selected)')
    $el.addClass('summary--selected')
    $el.find('[data-zefix-select]').remove()
    $el.siblings('.summary').remove()
    $getInput().val('')

    $confirmRegister = $el.closest('[data-zefix-confirm-register]')

    if $confirmRegister.length
      label = $confirmRegister.data('zefix-confirm-register')
      $el.find('.info').append(" <i class=\"material-icons small text-success\" title=\"#{label}\">check</i>")

    $.getJSON $el.data('zefix-result'), (data) -> fillData $el.parents('form'), data

fillData = ($form, data, state = 'result') ->
  $form.find('[name*="[zefix_state]"]').val(state)
  for key in _.keys(data)
    $form.find("[name*=\"[#{key}]\"]").val(data[key])

zefixSearch = ->
  $el = $getInput()
  query = $.trim($el.val())

  if query.length >= 3
    if _xhr
      _xhr.abort()
      _xhr = null

    startLoading()

    _xhr = $.get($el.data('zefix'), { q: query })
      .done (html) -> showResult(html)
      .fail (req) ->
        showResult req?.responseText || $('<p class="text-warning"></p>').text($CAM.t('zefix', 'error'))
  else
    showResult $('<p class="text-warning"></p>').text($CAM.t('zefix', 'input'))

startLoading = ->
  $('[data-zefix-loading]').show()
  $('[data-zefix-results]').hide()

showResult = (html) ->
  $('[data-zefix-results]').html(html).fadeIn()
  $('[data-zefix-loading]').hide()

$getInput = ->
  $('input[data-zefix]')

# Result selection
$(document).on 'click', '[data-zefix-result]', (evt) ->
  evt.preventDefault()
  selectResult $(this)

$(document).on 'click', '[data-zefix-select]', (evt) ->
  evt.preventDefault()
  evt.stopPropagation()
  selectResult $(this).parents('[data-zefix-result]')

# Manual entering
$(document).on 'click', 'a[data-zefix-manual],a[data-zefix-search]', (evt) ->
  evt.preventDefault()
  $this = $(this)
  $org = $($this.attr('href'))

  fillData $org, {}, 'manual'

  field = if $this.data('zefix-manual') then '[data-zefix-search]' else '[data-zefix-manual]'

  $this.parents(field).slideUp()
  $org.slideDown -> $org.find('input[autofocus]:first').focus()
  $org.find('*').each (_, el) -> el.dispatchEvent(customEvent)
  $selects = $('.selectpicker')
  $selects.selectpicker('refresh') if $selects.length > 0

# Searching
$(document).on 'keypress', 'input[data-zefix]', (evt) ->
  if evt.characterCode == K_ENTER
    evt.preventDefault()
    zefixSearch()

$(document).on 'click', 'button[data-zefix]', (evt) ->
  evt.preventDefault()
  zefixSearch()
